import React, { useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const SignupComplete: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSession } = useAuth() as any; // 나중에 타입 수정

  const session = (location.state as any)?.session;
  const user = (location.state as any)?.user;

  // 자동 로그인 처리
  useEffect(() => {
    if (session && setSession) {
      // AuthContext에 세션 설정 (마이그레이션 후)
      setSession(session, user);
    }
  }, [session, user, setSession]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 bg-gray-50 py-12 mt-20">
        <div className="max-w-5xl mx-auto px-4">
        {/* Contents Head */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <h3 className="text-3xl font-bold text-gray-900">통합회원가입</h3>
            <div className="flex gap-4 text-sm">
              <Link to="/login" className="text-gray-600 hover:text-[#48c9a6]">로그인</Link>
              <Link to="/signup" className="text-[#48c9a6] font-medium">통합회원가입</Link>
            </div>
          </div>
          <div className="h-1 bg-[#48c9a6] w-20 mt-4"></div>
        </div>

        {/* Contents Body */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          {/* 가입 완료 타이틀 */}
          <div className="flex items-center gap-3 mb-8 pb-4 border-b border-gray-200">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span className="text-xl font-bold text-gray-900">가입 완료</span>
          </div>

          {/* 완료 메시지 */}
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircleIcon className="h-16 w-16 text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                가입 완료!
              </h2>
              <p className="text-gray-600">
                동두천시 글로벌인재교육센터 회원가입이 완료되었습니다.
              </p>
            </div>

            {user && (
              <div className="mb-8 p-6 bg-[#48c9a6]/5 border border-[#48c9a6]/30 rounded-lg">
                <div className="text-sm space-y-3">
                  <div className="flex">
                    <span className="text-gray-600 w-24">이름:</span>
                    <span className="font-medium text-gray-900">{user.name}</span>
                  </div>
                  <div className="flex">
                    <span className="text-gray-600 w-24">아이디:</span>
                    <span className="font-medium text-gray-900">{user.username}</span>
                  </div>
                  <div className="flex">
                    <span className="text-gray-600 w-24">이메일:</span>
                    <span className="font-medium text-gray-900">{user.email}</span>
                  </div>
                  <div className="flex">
                    <span className="text-gray-600 w-24">회원 유형:</span>
                    <span className="font-medium text-gray-900">
                      {user.user_type === 'adult' && '일반회원'}
                      {user.user_type === 'minor' && '14세 미만 회원'}
                      {user.user_type === 'guardian' && '학부모 회원'}
                      {user.user_type === 'institution' && '기관'}
                    </span>
                  </div>
                </div>
              </div>
            )}

            <div className="space-y-3">
              <button
                onClick={() => navigate('/')}
                className="w-full flex justify-center py-3 px-4 border border-transparent text-base font-medium rounded-lg text-white bg-[#48c9a6] hover:bg-[#3ab89a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#48c9a6] transition-colors"
              >
                메인으로 가기
              </button>

              {!session && (
                <button
                  onClick={() => navigate('/login')}
                  className="w-full flex justify-center py-3 px-4 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#48c9a6] transition-colors"
                >
                  로그인하기
                </button>
              )}
            </div>

            {user?.user_type === 'guardian' && (
              <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                <p className="text-sm text-yellow-800">
                  💡 학부모 회원으로 가입하셨습니다.<br />
                  마이페이지에서 자녀 정보를 등록하신 후 수강신청이 가능합니다.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      </div>

      <Footer />
    </div>
  );
};

export default SignupComplete;
